import React from "react";
import { StyledPageFooter } from "./pageFooter/styled";

const PageFooter = ({ children }) => (
  <StyledPageFooter>{children}</StyledPageFooter>
);

export default PageFooter;
